import { render } from "./ProveedoresList.vue?vue&type=template&id=51687d4f"
import script from "./ProveedoresList.vue?vue&type=script&lang=js"
export * from "./ProveedoresList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__